<template>
  <div class="fixed-bot">
    <div class="page-width" style="position: relative;">
      <span>配送千万家商户 成就更好的自己</span>
      <a @click="handleClick" data-toggle="modal" data-target="#sj-enlist">我要成为美菜合作司机</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "bottomBar",
  data() {
    return {

    }
  },
  methods: {
    handleClick() {
      this.$emit("change", true)
    }
  }
}
</script>

<style lang="scss" scoped>
.fixed-bot {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  background: #f4f4f4;
  span {
    line-height: 58px;
    color: #c0c0c0;
    font-size: 26px;
  }
  a {
    position: absolute;
    right: 0;
    top: -1px;
    height: 60px;
    width: 280px;
    background: #4bc17c;
    color: #fff;
    font-size: 20px;
    text-align: center;
    line-height: 60px;
    &:hover {
      background: #41b571;
    }
  }
}
</style>
